import { z } from "zod";
import { searchParam } from "@amber/ui";
import { signInRefusalSchema } from "../contracts/index";

export const signInSearchSchema = z.object({
  invitation: searchParam(z.string()),
  refused: searchParam(signInRefusalSchema),
  invited: searchParam(z.string()),
  return_to: searchParam(z.string()),
  signed_out: searchParam(z.string()),
});
export type SignInSearch = z.infer<typeof signInSearchSchema>;

const USERS_TABS = ["users", "domains", "credentials"] as const;
const MEMBER_FILTERS = ["all", "active", "invited", "deactivated"] as const;
export type MemberFilter = (typeof MEMBER_FILTERS)[number];

export const usersSearchSchema = z.object({
  tab: searchParam(z.enum(USERS_TABS)),
  status: searchParam(z.enum(MEMBER_FILTERS)),
  selected: searchParam(z.string()),
});
export type UsersSearch = z.infer<typeof usersSearchSchema>;
